import { CHANNEL } from './share/constant';
const ua = navigator.userAgent.toLowerCase();
export default class Client {
  static isApple() {
    return ua.match(/iphone/i) || ua.match(/ipad/i) || ua.match(/ipod/i);
  }
  static isAndroid() {
    return /android/i.test(ua);
  }
  static isWindVane() {
    return /windvane/.test(ua);
  }
  static isAliApp() {
    return /(aliapp)+[\s]*/.test(ua);
  }
  static isAliyunApp() {
    return /aliyun/.test(ua);
  }
  static isWeixin() {
    return /MicroMessenger/i.test(ua);
  }
  static isMobile() {
    return window.isMobile || !!ua.match(/(android|iphone|ipod|ipad|windows\sphone)/gm) || window.innerWidth < 768;
  }
  static isQQ() {
    return ua.indexOf('mqqbrowser/') > -1;
  }
  static isUC() {
    return ua.indexOf('ucbrowser/') > -1;
  }
  static getChannel() {
    if (!Client.isMobile()) {
      return CHANNEL.PCBROWSER;
    } else if (Client.isAliyunApp()) {
      return CHANNEL.ALIYUN;
    } else if (Client.isWeixin()) {
      return CHANNEL.WEIXIN;
    } else if (Client.isQQ()) {
      return CHANNEL.QQ;
    } else if (Client.isUC()) {
      return CHANNEL.UC;
    } else {
      return CHANNEL.H5BROWSER;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/client.js